import { Box } from '@opendoor/bricks-next';
import { ThemedLite } from '@opendoor/bricks/theme/ODThemeLite';

import { EntryComponent } from '../../cms/entries/entries';
import { IComponentMetricsCard, IMetricBasic } from '../../declarations/contentful';
import BasicMetric from './BasicMetric';

const renderMetricsCard = (entry: IComponentMetricsCard) => {
  return (
    <Box className="embedded-entry-wrapper" $platform-web={{ gridColumn: '5 / -2' }}>
      <ThemedLite theme="legacy">
        <Box
          gap="$10x"
          py="$6x"
          width="100%"
          flexWrap="nowrap"
          flexDirection="column"
          $largerThanSM={{ flexWrap: 'wrap', flexDirection: 'row' }}
        >
          {entry.fields.metrics?.map((x) => {
            if (x.sys.contentType.sys.id === 'metricBasic') {
              return BasicMetric.render(x as IMetricBasic);
            }
            return null;
          })}
        </Box>
      </ThemedLite>
    </Box>
  );
};

const MetricsCard: EntryComponent<IComponentMetricsCard> = {
  render: renderMetricsCard,
};

export default MetricsCard;
